import { AnimatePresence } from 'framer-motion'
import React, { useEffect } from 'react'
// import ReactGA from 'react-ga'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

// import ym from 'react-yandex-metrika'
import { Container } from '../../components/Container/Container'
import { Feedback } from '../../components/Feedback/Feedback'
import { InformationBlock } from '../../components/ProjectPage/InformationBlock/InformationBlock'
import ProjectApartmentLayout from '../../components/ProjectPage/ProjectApartmentLayout/ProjectApartmentLayout'
import { ProjectCarousel } from '../../components/ProjectPage/ProjectCarousel/ProjectCarousel'
import { ProjectDescription } from '../../components/ProjectPage/ProjectDescription/ProjectDescription'
import { ProjectFeatures } from '../../components/ProjectPage/ProjectFeatures/ProjectFeatures'
import { ProjectFilters } from '../../components/ProjectPage/ProjectFilters/ProjectFilters'
import ProjectTable from '../../components/ProjectPage/ProjectTable/ProjectTable'
import { SimilarProjects } from '../../components/ProjectPage/SimilarProjects/SimilarProjects'
import { BackButton } from '../../components/UI/BackButton/BackButton'
import { Layout } from '../../components/UI/Layout/Layout'
import Preloader from '../../components/UI/Preloader/Preloader'
import { fetchProjectRequest } from '../../store/project/actions'
import { getProject } from '../../store/project/project'

export const ProjectPage = () => {
  const { id } = useParams()
  const { error, project, pending } = useSelector(getProject)
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(fetchProjectRequest({ id }))
  }, [id])

  return (
    <>
      <AnimatePresence>
        {pending || !project ? (
          <Preloader key='preloader' classModifiers={['screen']} />
        ) : (
          <Layout isWhite>
            <Container>
              <BackButton url='/' isWhite />
            </Container>
            <div>
              <InformationBlock
                shortName={project.short_name}
                address={project.address}
                readyPeriod={project.ready_period}
                presentReady={project.present_ready}
                cnt={project.cnt}
                prices={project.prices}
                projectUrl={project.projectUrl}
                presentNotReady={project.presentNotReady}
                id={id}
              />

              <ProjectCarousel
                slides={project.slides}
                genplan={project.genplan[0]}
              />
              <Container>
                <ProjectFilters id={id} />
                {project.description && (
                  <ProjectDescription text={project.description} />
                )}
                {project.specifications.length > 0 && (
                  <ProjectFeatures
                    carouselCards={project.specifications}
                    projectName={project.short_name}
                  />
                )}
                <ProjectTable />
                {project.plans.length > 0 && (
                  <ProjectApartmentLayout plans={project.plans} id={id} />
                )}
                {project.other.length > 0 && (
                  <SimilarProjects
                    other={project.other}
                    currentProject={project.short_name}
                  />
                )}
              </Container>
              <Feedback />
            </div>
          </Layout>
        )}
      </AnimatePresence>
    </>
  )
}
